module.exports = __webpack_public_path__ + "static/media/Vintage_main.87838982.jpg";